import { Action } from 'redux'
import { IModalReservationValues } from '../../../containers/Form/CreateReservation/withReduxForm'
import { ConfigurationModalActions } from '../../../reducers/bookingCalendar/actionNames'

const changeReservationFormConfiguration = (
  event: IModalReservationValues,
  formName: string,
): IChangeReservationFormConfiguration => ({
  event,
  formName,
  type: ConfigurationModalActions.ChangeConfiguration,
})

export interface IChangeReservationFormConfiguration
  extends Action<ConfigurationModalActions.ChangeConfiguration> {
  event: IModalReservationValues
  formName: string
}

export default changeReservationFormConfiguration
